module.exports = __webpack_public_path__ + "img/live.e87b29d3.svg";